import { render, staticRenderFns } from "./pdetail.vue?vue&type=template&id=5c9276de&scoped=true&"
import script from "./pdetail.vue?vue&type=script&lang=js&"
export * from "./pdetail.vue?vue&type=script&lang=js&"
import style0 from "./pdetail.vue?vue&type=style&index=0&id=5c9276de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9276de",
  null
  
)

export default component.exports